var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Loadable from 'react-loadable';
var path = require('path');

function Loading() {
  return React.createElement(
    'div',
    null,
    'RX Loading...'
  );
}

var logdown = require('logdown');
var console = logdown('rx-dashboard-routes', { prefixColor: '#00bcd4' });

function getLoadableComponent(route, configurations, loaders, global, loadingFunc) {

  var module = undefined;
  var subComponentName = undefined;
  var routes = route.page.split(".");
  var importFunction = undefined;
  if (route.loader) {
    console.log('loaders ' + Object.keys(loaders));
    console.log('use custom loader ' + route.loader);
    importFunction = function importFunction() {
      return loaders[route.loader](route.page);
    };
    if (routes.length > 1) {
      subComponentName = routes[1];
    }
  } else {
    console.log('in normal path');
    if (routes.length > 1) {
      module = './config/modules/' + routes[0];

      subComponentName = routes[1];
      console.log('found subComponent with name ' + subComponentName + ' for module ' + module);
      importFunction = function importFunction() {
        return import('' + module);
      };
    } else {
      module = './pages/' + route.page;
      console.log('load 2 simple page from ' + module);
      importFunction = function importFunction() {
        return import('' + module);
      };
    }
  }

  return Loadable({
    loader: function loader() {
      return importFunction().then(function (success) {
        console.log('in success load');
        return success;
      }).catch(function (error) {
        console.log('Error loading component: ' + error);
      });
    },
    render: function render(Component, props) {

      //Inject local module configuration with global configurations
      var parameters = route.parameters ? route.parameters : {};
      parameters = _extends({ global: global }, parameters);

      if (route.configuration) {
        var configuration = configurations[route.configuration] ? configurations[route.configuration] : {};
        parameters = _extends({}, configuration, parameters);
      }

      if (subComponentName) {
        var SubComponent = undefined;
        if (Component.default) {
          SubComponent = Component.default[subComponentName];
        } else {
          SubComponent = Component[subComponentName];
        }
        if (route.aside) {
          // console.log(`component: ${Object.keys(Component)}`)
          var ASideComponent = Component[route.aside];
          // console.log(`aside: ${ASideComponent}`)
          return React.createElement(SubComponent, _extends({ aside: ASideComponent }, _extends({}, parameters, props)));
        }
        return React.createElement(SubComponent, _extends({}, parameters, props));
      }
      return React.createElement(Component.default, _extends({}, parameters, props));
    },

    loading: loadingFunc,
    delay: 400

  });
}

export var getRoutes = function getRoutes(configuration, loaders, loading) {

  var baseRoutes = [];

  return [].concat(baseRoutes, configuration.routes.map(function (route, index) {
    console.log('iterate for ' + JSON.stringify(route));
    return { path: route.path, name: route.name, component: getLoadableComponent(route, configuration.configurations, loaders, configuration, loading) };
  }));
};

export var getPublicRoutes = function getPublicRoutes(configuration, loaders, loading) {

  var baseRoutes = [];

  return [].concat(baseRoutes, configuration.publicRoutes.map(function (route, index) {
    console.log('public iterate for ' + JSON.stringify(route));
    return { path: route.path, name: route.name, component: getLoadableComponent(route, configuration.configurations, loaders, configuration, loading) };
  }));
};

// export default getRoutes;